export const scrollToStep = step =>
  step.ref.current.scrollIntoView({ behavior: 'smooth' });

export const scrollToBottom = ref =>
  setTimeout(
    () =>
      ref.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      }),
    10,
  );

export const scrollToView = ref => {
  if (!ref) return null;

  return setTimeout(
    () =>
      ref.scrollIntoView({
        behavior: 'smooth',
      }),
    10,
  );
};

export const scrollToRef = ref => {
  const headerOffset = 75; // offsets the navbar
  const elementPosition = ref.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
